import {
  ArticleError,
  ArticleGenerating,
} from '@/components/articles/ArticleStatus'
import { ArticleView } from '@/components/articles/ArticleView'
import { orpc } from '@/lib/orpc/client'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, useRouter } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/article/$articleId')({
  component: RouteComponent,
  loader: async ({ params, context }) => {
    await context.queryClient.ensureQueryData(
      orpc.articles.getArticleInfoById.queryOptions({
        input: { articleId: params.articleId },
      }),
    )
  },
})

function RouteComponent() {
  const params = Route.useParams()
  const { data: article } = useQuery(
    orpc.articles.getArticleInfoById.queryOptions({
      input: { articleId: params.articleId },
    }),
  )

  if (!article) {
    return <ArticleError status="not-found" id={params.articleId} />
  }

  if (article.status === 'writing') {
    return <ArticleGeneratingWrapper />
  }

  // Show error for any non-complete status
  if (article.status !== 'published' && article.status !== 'draft') {
    return <ArticleError status={article.status} id={article.id} />
  }

  return <ArticleView article={article} />
}

function ArticleGeneratingWrapper() {
  const router = useRouter()
  const { articleId } = Route.useParams()
  return (
    <ArticleGenerating
      articleId={articleId}
      onComplete={() => {
        router.invalidate()
      }}
    />
  )
}
